export const ToastSuccessIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM12.0029 5.15723C11.6953 4.8402 11.1882 4.83213 10.8711 5.13965L6.71387 9.16992L5.12891 7.63379C4.81174 7.32623 4.30465 7.33327 3.99707 7.65039C3.68951 7.96758 3.69747 8.47466 4.01465 8.78223L6.15723 10.8604C6.46749 11.161 6.96123 11.161 7.27148 10.8604L11.9854 6.28809C12.3024 5.98058 12.3103 5.47441 12.0029 5.15723Z"
        fill="#12B981"
      />
    </svg>
  )
}
